export const Onboard = {
	expiredContent: {
		title: "⚠️ Din onboarding-lenke har utløpt",
		description: `
Oops! Denne lenken er ikke lenger aktiv. Onboarding-lenker utløper etter en viss periode eller kan bare brukes én gang.
Hvis du ikke har satt opp kontoen din ennå, be administratoren din om å sende en ny invitasjon.
`,
		footer_content: "Hvis du allerede har fullført onboarding, kan du",
	},
	unknow_error: {
		title: "En uventet feil oppstod",
		description: "En uventet feil har oppstått. Prøv igjen senere eller kontakt support hvis problemet vedvarer.",
	},
	form: {
		title: "Velkommen",
		description:
			"Du har blitt invitert til å bli med i {{organizationName}} på Lens. La oss få deg satt opp og klar til å starte!",
		button_text: "Bli med i {{organizationName}}",
		button_text_loading: "Onboarding...",
	},
	login_link_text: "Logg inn",
};
